var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.405 21.404a1.938 1.938 0 000-2.797l-14.143-13.5a1.921 1.921 0 00-2.724.065 1.928 1.928 0 00.065 2.724l10.655 10.181H3.928c-1.068 0-1.928.86-1.928 1.929 0 1.068.86 1.928 1.929 1.928h27.329L20.595 32.107a1.928 1.928 0 00-.065 2.724 1.928 1.928 0 002.724.065l14.143-13.5.008.008z"
  })));
}
export default SvgArrowRight;